import toast, { Toaster as HotToaster, ToastBar } from 'react-hot-toast';
import { X } from 'lucide-react';

/**
 * Configured Toaster component
 * Styled to match the app design system
 */
export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      gutter={8}
      containerStyle={{
        top: 16,
        right: 16,
      }}
      toastOptions={{
        duration: 4000,
        style: {
          background: 'hsl(var(--background))',
          color: 'hsl(var(--foreground))',
          border: '1px solid hsl(var(--border))',
          borderRadius: 'var(--radius)',
          fontSize: '14px',
          padding: '12px 16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        },
        success: {
          iconTheme: {
            primary: 'hsl(142.1 76.2% 36.3%)', // green-600
            secondary: 'white',
          },
        },
        error: {
          iconTheme: {
            primary: 'hsl(var(--destructive))',
            secondary: 'white',
          },
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <button
                  onClick={() => toast.dismiss(t.id)}
                  className="ml-2 rounded-sm opacity-70 hover:opacity-100 focus:outline-none"
                >
                  <X className="h-4 w-4" />
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </HotToaster>
  );
}
